import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DialogActions } from 'src/app/model/dictionary';

export interface PacoDialogAction {
  name: DialogActions;
  labelKey: string;
  color?: 'primary' | 'accent' | 'warn';
  disabled?: boolean;
}

@Component({
  selector: 'app-paco-dialog',
  templateUrl: './paco-dialog.component.html',
  styleUrls: ['./paco-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PacoDialogComponent {

  readonly title = input<string>('');
  readonly text = input<string>('');
  readonly actions = input<PacoDialogAction[]>([]);

  readonly actionTriggered = output<DialogActions>();

  onActionClick(action: PacoDialogAction): void {
    if (action.disabled) { return; }
    this.actionTriggered.emit(action.name);
  }
}
